import { FONT_FAMILY } from "@/constants";
import Link from "@mui/material/Link";
import { ReactNode } from "react";
import { Link as RouterLink } from "react-router-dom";

type AuthTextLinkProps = {
  children: ReactNode;
  disabled?: boolean;
} & (
  | { /** In-app route (SPA navigation). */ to: string; href?: never }
  | { /** External page, opened in a new tab. */ href: string; to?: never }
);

/** Text link for auth screens (Poppins, primary underline). */
export default function AuthTextLink({ to, href, children, disabled }: AuthTextLinkProps) {
  const target = href
    ? { href, target: "_blank", rel: "noopener noreferrer" }
    : { component: RouterLink, to };

  return (
    <Link
      {...target}
      aria-disabled={disabled || undefined}
      tabIndex={disabled ? -1 : undefined}
      sx={{
        fontFamily: FONT_FAMILY,
        fontWeight: 600,
        fontSize: "inherit",
        letterSpacing: "inherit",
        color: "primary.main",
        textUnderlineOffset: "2px",
        pointerEvents: disabled ? "none" : "auto",
        opacity: disabled ? 0.5 : 1,
      }}
    >
      {children}
    </Link>
  );
}
